import { render, staticRenderFns } from "./AccreditationAgreedSign.vue?vue&type=template&id=2ff9fc87&scoped=true"
import script from "./AccreditationAgreedSign.vue?vue&type=script&lang=js"
export * from "./AccreditationAgreedSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9fc87",
  null
  
)

export default component.exports